// extracted by mini-css-extract-plugin
export default {"root":"_1VUrY","color-green":"OhQ-H","colorGreen":"OhQ-H","color-red":"_2sWE3","colorRed":"_2sWE3"};